
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[typeOrDistance]",
      function () {
        return require("private-next-pages/[typeOrDistance]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[typeOrDistance]"])
      });
    }
  